import { EnvBadge, Table, UserInfo, When } from '@/components';
import { useNavigate } from '@solidjs/router';
import type { PromotionHop } from '@uchat-team-management/shared';
import { Show } from 'solid-js';
import { ReleaseStatusBadge } from './ReleasesTable';

/** UCH-436: the release's promotion chain (dev→sit→uat→prd), current hop highlighted. */
export const PromotionTrailCard = (props: { trail: PromotionHop[]; currentId: string }) => {
  const navigate = useNavigate();
  return (
    <Show when={props.trail.length > 0}>
      <div class="mt-6 rounded-xl border border-neutral-200 bg-surface p-4 dark:border-neutral-800 dark:bg-surface-dark">
        <h2 class="mb-3 font-medium">Promotion trail</h2>
        <Table
          data={props.trail}
          rowKey={(hop) => hop.id}
          current={(hop) => hop.id === props.currentId}
          onRowClick={(hop) => navigate(`/release/versions/${hop.id}`)}
          columns={[
            {
              key: 'environment',
              header: 'Environment',
              render: (hop) => <EnvBadge env={hop.environment} />,
            },
            {
              key: 'version',
              header: 'Version',
              render: (hop) => (
                <span class="font-medium">
                  {hop.version}{' '}
                  <span class="font-normal text-neutral-400">build #{hop.buildNumber}</span>
                </span>
              ),
            },
            {
              key: 'commit',
              header: 'Commit',
              render: (hop) => (
                <code class="text-xs text-neutral-600 dark:text-neutral-400">
                  {hop.commitSha.slice(0, 7) || '—'}
                </code>
              ),
            },
            {
              key: 'status',
              header: 'Status',
              render: (hop) => <ReleaseStatusBadge status={hop.status} />,
            },
            {
              key: 'promotedBy',
              header: 'Promoted by',
              render: (hop) => (
                <Show when={hop.promotedBy} fallback={<span class="text-neutral-500">origin</span>}>
                  {(by) => <UserInfo user={by()} />}
                </Show>
              ),
            },
            {
              key: 'when',
              header: 'When',
              align: 'right',
              render: (hop) => <When date={hop.createdAt} />,
            },
          ]}
        />
      </div>
    </Show>
  );
};
